import { createFileRoute } from '@tanstack/react-router'
import { shopRepository } from '@/data/adapters/api/shop.api'
import { useAppStore } from '@/stores/app.store'

export const Route = createFileRoute('/$orgSlug/$clientSlug/shop')({
  // Prefetch the range the page will actually request. A hardcoded window
  // fires a query whose key never matches the page's, wasting a round trip.
  loader: ({ context: { queryClient, client } }) => {
    const range = useAppStore.getState().dateRange
    return queryClient.ensureQueryData({
      queryKey: ['shop', 'daily', client.id, range.from.toISOString(), range.to.toISOString()],
      queryFn: () => shopRepository.getDailyMetrics(client.id, range),
    })
  },
})
